'use strict';

angular.module('amexReconciliationApp')
  .service('TransactionReceiptRepository', function ($resource) {
    var self = this;
    var transactionReceiptsResource = $resource(
      '/api/v1/transactions/:transactionId/receipts/:receiptId', {},
      {
        'get': {method: 'GET', isArray: true},
        'delete': {method: 'DELETE', isArray: true}
      }
      );
    var transactionReceiptsPostResource = $resource(
      '/api/v1/transactions/receipts/match', {},
      {
        'save': {method: 'POST', isArray: true}
      }
    );

    self.findReceiptsByTransaction = function (transaction) {
      return transactionReceiptsResource
        .get({ transactionId: transaction.id })
        .$promise;
    };

    self.matchReceiptsToTransaction = function (receiptsToMatch, transactions) {
      var receiptIds = _.map(receiptsToMatch, 'id');
      var transactionIds = _.map(transactions, 'id');
      var postData = {receiptIds: receiptIds, transactionIds: transactionIds};

      return transactionReceiptsPostResource
        .save(postData)
        .$promise;
    };

    self.unmatchReceiptFromTransaction = function (receipt, transaction) {
      return transactionReceiptsResource
        .delete({ transactionId: transaction.id, receiptId: receipt.id }, undefined)
        .$promise;
    };

  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/repositories/TransactionReceiptRepository.js
// module id = 626
// module chunks = 0